import React from 'react';
import styled from "styled-components";

const SGrammarTemporales = styled.div`
  flex: 1;
  padding: 5px 20px;
`;

const GrammarTemporales = () => {
  return (
    <SGrammarTemporales>
<h5>Zdania czasowe (Frases temporales)</h5>

Zdania czasowe wprowadzają określone spójniki, które można podzielić
 na kilka grup, które mogą wyrażać:<br/>
- czynności wcześniejsze<br/>
- czynności równoczesne<br/>
- czynności późniejsze<br/>
- czynności powtarzające się<br/>
- rozpoczynanie czynności<br/>
- zakończenie czynności<br/><br/>

Najczęściej używane spójniki:<br/>
<table>
<tr><td width="200"><b>Antes de<br/>Después de<br/>Al<br/>
Hasta<br/>Nada más</b></td>
<td>+ <b>infinitivo</b></td></tr>
<tr><td width="200"><b>Antes de que</b></td>
<td>+ <b>subjuntivo</b></td></tr>
<tr><td width="200"><b>Desde que<br/>Mientras que</b></td>
<td>+ <b>indicativo</b></td></tr>
<tr><td width="200"><b>Cuando<br/>En cuanto<br/>Tan pronto como<br/>
Hasta que<br/>Siempre que<br/>Mientras<br/>Apenas<br/>Cada vez que<br/>
A medida que</b></td>
<td>+ <b>indicativo / subjuntivo</b></td></tr>
</table>
<br/>

<li>czynności wcześniejsze:<br/>
<i><b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;antes de + infinitivo<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;antes de que + subjuntivo</b></i><br/>
<i>Antes de acostarse apagó la tele.</i> - Zanim się położył/a spać, zgasił/a telewizor.<br/>
<i>Lo terminaremos antes de que vuelva el jefe.</i> - Skończymy to, zanim wróci szef.<br/>
<i>Se acostó antes de que volvieran sus padres.</i> - Położył/a się spać, zanim wrócili jego/jej rodzice.
<br/><br/></li>

<li>czynności równoczesne:<br/>
<i><b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;cuando<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;mientras<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;en el (mismo) momento<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a medida que<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al + infinitivo</b></i><br/>
*gdy mowa o czynności przyszłej, po tych spójnikach używa się subjuntivo
<br/><br/></li>

<li>czynności przeciwstawne:<br/>
<i><b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;mientras tanto<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;en cambio<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;entre tanto</b></i><br/>
<i>Cuando visitaba a su abuela, le llevaba bombones.</i> -
 Kiedy odwiedzał/a swoją babcię, zanosił/a jej czekoladki.<br/>
<i>Cuando llegó Juan, todos se alegraron.</i> -
 Kiedy przyszedł Jan, wszyscy się ucieszyli.<br/>
<i>Cuando vengas, veremos la tele.</i> -
 Kiedy przyjdziesz, obejrzymy telewizję.<br/>
<i>Al salir de la oficina, vio a su mujer con un hombre.</i> -
 Wychodząc z biura zobaczył swoją żonę z jakimś mężczyzną.<br/>
<i>Estaba leyendo una revista en el salón, en cambio su amiga
 preparaba un pastel en la cocina.</i> - Czytał/a casopismo w salonie,
  natomiast jego/jej przyjaciółka przygotowywała ciasto w kuchni.
<br/><br/></li>

<li>czynności późniejsze:<br/>
<i><b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;cuando<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;después de + infinitivo<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;nada más + infinitivo<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;en cuanto<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;tan pronto<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;como<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;apenas</b></i><br/>
*gdy mowa o czynności przyszłej, po tych spójnikach używa się subjuntivo<br/>
<i>Nada más entrar en la oficina, se dieron cuenta de que estaba
 pasando algo raro.</i> - Jak tylko weszli do biura, zdali sobie
  sprawę, że dzieje się cos dziwnego.<br/>
<i>Tan pronto como se acuesta, se duerme.</i> -
 Jak tylko kładzie się do łóżka, zasypia.<br/>
<i>Tan pronto como llegues a Burgos, me llamas.</i> -
 Jak tylko przyjedziesz do Burgos, zadzwonisz do mnie.
<br/><br/></li>

<li>czynności powtarzające się:<br/>
<i><b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;cada vez que<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;siempre que<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;cuando ... nunca<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;nunca cuando</b></i><br/>
*gdy mowa jest o czynności przyszłej, po tych spójnikach używa się subjuntivo<br/>
<i>Cada  vez que se va de viaje, se olvida de llevar algo.</i> -
 Za każdym razem, gdy jedzie w podróż, zapomina coś zabrać.<br/>
<i>Siempre que vayas de compras, apunta las cosas que necesitas.</i> -
 Zawsze, gdy będziesz szedł/szła na zakupy, zapisz rzeczy, których potrzebujesz.<br/>
<i>Cuando le llamo, nunca se pone.</i> - Gdy do niego dzwonię, nigdy nie
 podchodzi do telefonu.
<br/><br/></li>

<li>rozpoczynanie czynności:<br/>
<i><b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;desde que + indicativo</b></i><br/>
<i>Desde que se quedó viuda, apenas sale de casa.</i> - Odkąd owdowiała, prawie nie
 wychodzi z domu.<br/>
<i>Desde que ha recibido el aumento, parece más tranquilo.</i> - Odkąd dostał
 podwyżkę, wydaje się spokojniejszy.
<br/><br/></li>

<li>zakończenie czynności:<br/>
<i><b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;hasta + infinitivo<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;hasta que + indicativo/subjuntivo</b></i><br/>
*subjuntivo wyraża czynności przyszłe<br/>
<i>Hasta llegar ella, el ambiente había sido más alegre.</i> - Dopóki ona nie przyszła, atmosfera była weselsza.<br/>
<i>Esperaron en la estación hasta que vino Pablo.</i> - Czekali na dworcu, aż przyszedł Paweł.<br/>
<i>Haremos la cola hasta que queden entradas.</i> - Będziemy stać w kolejce dopóki będą bilety.
<br/><br/></li>

<b>Uwaga!</b> W mowie zależnej przestrzega się tych samych zasad użycia subjuntivo.<br/>
<i>Dijo que cuando tuviera tiempo, iríamos al cine.</i> - Powiedział/a, że kiedy
będzie miał/a czas, pójdziemy do kina.<br/>
<i>Dijo que estaría en casa hasta que volviera su marido.</i> - Powiedziała, że będzie
w domu aż do powrotu męża.
    </SGrammarTemporales>
  )
};

export default GrammarTemporales;